<script lang="ts">
  import { goto } from '$app/navigation';
  import type { TopDonorsItem } from '$src/utils/api/topDonors.util';
  import { onMount } from 'svelte';
  import Crown from './Crown.svg.svelte';

  export let donationData: TopDonorsItem;
  export let position: number;
  export let skelet = false;
  let gradient: string;

  const postitions = {
    1: '--first-gradient',
    2: '--second-gradient',
    3: '--third-gradient'
  };

  onMount(() => {
    gradient = postitions[position];
  });
</script>

<button
  on:click={() => {
    goto(`profile/${donationData.userName}`);
  }}
  class="group flex flex-col"
  class:translate-y-5={position !== 1}
>
  <div class="flex-grow flex flex-col items-center">
    <div class="flex-grow" />

    <div class="w-3/5 mb-2 relative">
      <!-- Crown for position 1 -->
      {#if position === 1}
        <div class="absolute inset-0 scale-125 translate-y-1">
          <div class="relative">
            <Crown />
          </div>
        </div>
      {/if}

      <div
        class="rounded-full relative w-full aspect-square overflow-hidden cursor-pointer"
        class:--skelet-bg={skelet}
      >
        {#if donationData?.profileImage}
          <img src={donationData?.profileImage} alt="" class="w-full aspect-square object-cover" />
        {:else}
          <img
            src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${donationData?.profileImage}`}
            alt=""
            class="w-full aspect-square object-cover"
          />
        {/if}
      </div>

      <div class="absolute -right-2 bottom-0 bg-white rounded-full p-[3px]">
        <div
          class="{gradient} rounded-full w-6 aspect-square grid place-items-center text-white text-sm font-bold"
        >
          {position}
        </div>
      </div>
    </div>
  </div>

  {#if skelet}
    <div class="rounded-lg --skelet-bg h-6 mb-2 w-[50px] mx-auto" />
  {:else}
    <div class="group-hover:underline text-center mb-2 font-medium text-sm text-accent-blue-80">
      {donationData?.userName || '...'}
    </div>
  {/if}

  <div
    class="bg-white pt-[10px] font-bold rounded-t-lg h-32 text-center text-sm text-accent-blue-70 relative min-w-[70px]"
  >
    {#if skelet}
      <div class="h-6 rounded-lg --skelet-bg mx-[10px]" />
    {:else}
      {donationData?.timeWindowDonatedSeed || '...'}
      <br />
      seeds
    {/if}

    <div
      class="text-7xl absolute inset-x-0 -bottom-4 text-blueish-grey-200 font-satoshi font-black"
    >
      {position}
    </div>
  </div>
</button>

<style>
  .--first-gradient {
    background: linear-gradient(180deg, #f9d488 0%, #dea021 100%);
  }

  .--second-gradient {
    background: linear-gradient(180deg, #cbcbcb 0%, #7b7b7b 100%);
  }

  .--third-gradient {
    background: linear-gradient(180deg, #ed8529 0%, #a33f23 100%);
  }
</style>
